export const AuthHeaderFlags = {
  /**
   * Da impostare a true per indicare che la richiesta è stata effettuata da
   * un polling; questo evita di rinnovare la sessione.
   */
  IsPolling: 'X-Frontend-Polling',
};
